var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{staticClass:"content"},[_c('landing-heading',{attrs:{"title":"Карта площадки"}})],1),_vm._v(" "),_c('landing-map-map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }